import { CloudyContactCard } from './cloudy-copiable-contact-card'

export function WhatsappCallCloudyCard() {
  return <WhatsappCloudyCard label="Nous appeler via Whatsapp" title="Appel Whatsapp" />
}

export function WhatsappMessageCloudyCard() {
  return <WhatsappCloudyCard label="Envoyer un message via Whatsapp" title="Message Whatsapp" />
}

/**
 * Les deux canaux Whatsapp, annoncés mais pas encore ouverts.
 *
 * Le libellé et la pastille « Bientôt disponible » sont empilés et non côte à
 * côte : sur une carte étroite, la pastille compressait le texte jusqu'à un mot
 * par ligne.
 */
function WhatsappCloudyCard({ label, title }: { label: string; title: string }) {
  return (
    <CloudyContactCard title={title}>
      <div className="flex cursor-not-allowed flex-col gap-2 opacity-90">
        <div className="flex items-center gap-3">
          <img alt="" aria-hidden className="size-8 shrink-0" src="/icons/whatsapp.svg" />
          <p className="min-w-0 text-sm font-medium text-white">{label}</p>
        </div>
        <span className="w-fit rounded-full bg-white/20 px-2 py-1 text-xs font-semibold text-white">
          Bientôt disponible
        </span>
      </div>
    </CloudyContactCard>
  )
}
